module.exports = __webpack_public_path__ + "img/1-1.5b0973a7.svg";